import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Layout, Button, Row, Col, Input, Form, Checkbox, Select, Icon } from 'antd'
import HandleDrugFamiliesPopup from '../../../components/Popup/HandleDrugFamilies'
@inject((store: any) => {
    const { drugsStore, popupStore } = store
    return { drugsStore, popupStore }
})
@observer
class SearchBar extends Component<any, any> {
    handleFilterChange = (name, value) => {
        const { setFilter, getDrugs } = this.props.drugsStore
        setFilter(name, value)
        getDrugs(1)
    }

    render() {
        const {
            drugsStore: { filters, getDrugs, resetFilters, paging, families, companies },
            popupStore: { togglePopup }
        } = this.props
        const resultsTitle = `נמצאו ${paging.total} תרופות `

        return (
            <>
                <Form
                    onSubmit={e => {
                        e.preventDefault()
                        getDrugs(1)
                    }}
                >
                    <Layout style={{ padding: '0 1rem' }}>
                        <Row gutter={28}>
                            <Col xs={3}>
                                <strong>חיפוש לפי מזהה</strong>
                                <Input.Search
                                    placeholder="הזן מזהה תרופה"
                                    value={filters.id}
                                    onChange={e => this.handleFilterChange('id', e.target.value)}
                                />
                            </Col>
                            <Col xs={4}>
                                <strong>חיפוש לפי משפחה</strong>
                                <Select
                                    id="set_lng"
                                    value={filters.family}
                                    style={{ width: '100%' }}
                                    placeholder="בחר משפחה"
                                    onChange={family => this.handleFilterChange('family', family)}
                                >
                                    <Select.Option value={null} key={'empty'}>
                                        כל המשפחות
                                    </Select.Option>
                                    <Select.Option value={'none'} key={'none'}>
                                        ללא משפחה
                                    </Select.Option>
                                    {families.map(slot => (
                                        <Select.Option value={slot.id} key={slot.id}>
                                            {slot.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                                <a
                                    onClick={() => togglePopup('handleDrugFamilies')}
                                    style={{ textDecoration: 'underline' }}
                                >
                                    <Icon type="edit" /> הוסף/הסר משפחות
                                </a>
                            </Col>
                            <Col xs={4}>
                                <strong>חיפוש במספר רישום</strong>
                                <Input.Search
                                    placeholder="הזן מס רישום"
                                    value={filters.registration_id}
                                    onChange={e => this.handleFilterChange('registration_id', e.target.value)}
                                />
                            </Col>
                            <Col xs={5}>
                                <strong>חיפוש חופשי בתיאור שם</strong>
                                <Input.Search
                                    placeholder="הזן שם תרופה"
                                    value={filters.name}
                                    onChange={e => this.handleFilterChange('name', e.target.value)}
                                />
                            </Col>
                            <Col xs={4}>
                                <strong>חיפוש חופשי במרכיבים</strong>
                                <Input.Search
                                    placeholder="הזן שם מרכיב"
                                    value={filters.ingredient}
                                    onChange={e => this.handleFilterChange('ingredient', e.target.value)}
                                />
                            </Col>
                            <Col xs={4} style={{ padding: '1.1rem' }}>
                                <Checkbox
                                    style={{ padding: '0.5rem' }}
                                    checked={filters.in_health_store}
                                    onChange={e => this.handleFilterChange('in_health_store', +e.target.checked)}
                                />
                                <strong>בסל הבריאות</strong>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={20}>
                                <Button
                                    style={{ margin: '0' }}
                                    onClick={() => {
                                        resetFilters()
                                        getDrugs(1)
                                    }}
                                >
                                    איפוס חיפוש
                                </Button>
                                <Button type="primary" style={{ margin: '0.8rem 0.5rem 0' }} htmlType="submit">
                                    חפש תרופות
                                </Button>
                                <span style={{ fontSize: '1rem', padding: '1rem' }}>{resultsTitle}</span>
                            </Col>
                        </Row>
                    </Layout>
                </Form>
                <HandleDrugFamiliesPopup />
            </>
        )
    }
}

export default withRouter(SearchBar)
